import { IconButton, Link } from '@chakra-ui/react';
import { FaEye } from 'react-icons/fa6';

import { TableColumn, dateTimeBodyRender } from '@app/components/common/table';
import { OutletHistoryItem } from '@app/api/models/acb';


import { FIELDS } from './contants';

export const useColumns = ({ onUpdateRequestClick }: {
  onUpdateRequestClick: (id: string) => void;
}): TableColumn<OutletHistoryItem>[] => {
  return [
    {
      name: 'id',
      label: '#',
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: 'create_dt',
      label: 'Дата/время',
      options: {
        filter: {
          name: 'create_date_range',
          type: 'date-range',
          onApply: (value) => value.map((date) => date.split('T')[0])
        },
        sort: false,
        customBodyRender: dateTimeBodyRender(),
      },
    },
    {
      name: 'outlet_id',
      label: 'ID ТТ',
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: 'field',
      label: 'Поле',
      options: {
        filter: {
          type: 'select',
          onOptionsFetch: () => Object.keys(FIELDS).map((id) => ({ id, name: FIELDS[id] })),           
        },
        sort: false,
        customBodyRender: (value: string) => {
          return <>{FIELDS[value] || value}</>;
        },
      },
    },
    {
      name: 'value',
      label: 'Новое значение',
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: 'user',
      label: 'Пользователь',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value: EntityBase) => {
          return <>{value?.full_name}</>;
        },
      },
    },
    {
      name: 'update_request_id',
      label: 'В рамках заявки',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value: string | null) => {
          if (!value) {return null;}
          return <Link
            // href={`/acl/updates-outlets/${value}/view`}
            onClick={() => {
              onUpdateRequestClick(value);
            }}
            target="_blank"
            rel="noopener noreferrer"
            color="brand.500"
            fontWeight="bold"
            _hover={{
              textDecoration: 'underline',
            }}
          >#{value}</Link>;
        }
      },
    },
    {
      name: 'full_name',
      label: 'Пользователь',
      options: {
        hidden: true,
        filter: true,
        sort: false,
      },
    }
    
  ];
};
